import { render, staticRenderFns } from "./SharedMediaFolderAdd.vue?vue&type=template&id=23b60624&"
import script from "./SharedMediaFolderAdd.vue?vue&type=script&lang=js&"
export * from "./SharedMediaFolderAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports